import { render } from "./NombreCompleto.vue?vue&type=template&id=50b296c6&scoped=true"
import script from "./NombreCompleto.vue?vue&type=script&lang=js"
export * from "./NombreCompleto.vue?vue&type=script&lang=js"

import "./NombreCompleto.vue?vue&type=style&index=0&id=50b296c6&scoped=true&lang=css"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/QuoteAndBuy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b296c6"]])

export default __exports__